import { render, staticRenderFns } from "./OrderFlowTable.vue?vue&type=template&id=82d89eb6&scoped=true&"
import script from "./OrderFlowTable.vue?vue&type=script&lang=js&"
export * from "./OrderFlowTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d89eb6",
  null
  
)

export default component.exports